import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import T from 'i18n-react';
import { PROVIDER_CONFIRM } from '../../routing';
import withStyles from '@material-ui/core/styles/withStyles';

const StyledButton = withStyles({
  root: {
    maxWidth: 300,
    width: '100%',
    margin: 'auto',
  },
})(Button);

type Props = Omit<ButtonProps, 'variant' | 'href'>;

const ProviderConfirmButton = (props: Props) => (
  <StyledButton variant="outlined" href={PROVIDER_CONFIRM} {...props}>
    {T.translate('logins.forgotProvider')}
  </StyledButton>
);

export default ProviderConfirmButton;
